
















import { Component, Prop, Vue } from 'vue-property-decorator'
import Modal from '@/app/ui/components/Modal/index.vue'
import Button from '@/app/ui/components/Button/index.vue'
import CloseCicleIcon from '@/app/ui/assets/icon_check_circle.vue'

@Component({
  components: {
    Modal,
    Button,
    CloseCicleIcon,
  },
})
export default class ModalSuccess extends Vue {
  @Prop({ default: false }) private visible!: boolean
  @Prop({ default: "Title" }) private title!: string
  @Prop({ default: "Description" }) private description!: string
}
